import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import productApi from 'src/api/product'

export const fetchStore = createAsyncThunk(
  'store/fetchStore',
  async () => {
    const response = await productApi.getAllListOfStore()
    // console.log("createProductThunk: ", response)
    return response
  }
)

const initialState = {
  isModalOpen: false,
  modalViewName: null,
  modalViewParams: null,
  detail: null,
  reload: false,

  storeList: [],
  status: '',
  loading: true,
  error: '',
}
const slice = createSlice({
  name: 'store',
  initialState,
  reducers: {
    createStore(oldState, action) {
      let newStore = action.payload
      oldState.storeList = [...oldState.storeList, newStore]
    },
    setStore(oldState, action) {
      let newStore = action.payload
      oldState.storeList = newStore
    },
    openModal(oldState) {
      oldState.isModalOpen = true
    },

    closeModal(oldState) {
      oldState.isModalOpen = false
      oldState.modalViewName = null
      oldState.modalViewParams = null
    },

    setModalViewName(oldState, action) {
      oldState.modalViewName = action.payload
    },

    setModalViewParams(oldState, action) {
      oldState.modalViewParams = action.payload
    },
    setReload(oldState, action) {
      oldState.reload = action.payload
    },
  },

  extraReducers: {
    [fetchStore.pending]: (state, action) => {
      state.status = 'loading'
      state.loading = true
    },
    [fetchStore.fulfilled]: (state, action) => {
      state.status = 'succeeded'
      state.storeList = action.payload
      state.loading = false
    },
    [fetchStore.rejected]: (state, action) => {
      state.status = 'failed'
      state.error = action.error.message
    },
  },
})

export const reducer = slice.reducer

/* Modal */
export const setModalViewName = (viewName) => (dispatch) => {
  dispatch(slice.actions.setModalViewName(viewName))
}

export const setModalViewParams = (params) => (dispatch) => {
  dispatch(slice.actions.setModalViewParams(params))
}

export const openModal = () => (dispatch) => {
  dispatch(slice.actions.openModal())
}

export const closeModal = () => (dispatch) => {
  dispatch(slice.actions.closeModal())
}

export const setReload = (reload) => (dispatch) => {
  dispatch(slice.actions.setReload(reload))
}

/* store dispatch */
export const createStore = () => async (dispatch) => {
  const result = await productApi.getAllListOfStore()
  dispatch(slice.actions.createStore(result))
}

export const setStore= () => async (dispatch) => {
    const result = await productApi.getAllListOfStore()
    // console.log(result.data.data.content)
    dispatch(slice.actions.setStore(result.data.data.content))
  }

export default slice
